// extracted by mini-css-extract-plugin
export var cardSelected = "_ge-2";
export var image = "_ge-1";
export var table = "_ge-0";